import View from './view';
import React from 'react';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';

export const NonFinancialTransportService = () => {
  const content = useSelector(contentSelector());
  return <View content={content} />;
};
